/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Description_Export_Event_Missing_EndInputs */

const en_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} is missing an end time.
 Would you like to ABORT your export?`)
};

const fr_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'événement ${i?.index} n'a pas d'heure de fin.
 Souhaitez-vous ABANDONNER l'exportation ?`)
};

const de_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für das Ereignis ${i?.index} fehlt eine Endzeit.
Möchten Sie den Export abbrechen?`)
};

const it_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All'evento ${i?.index} manca un orario di fine.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} не имеет времени окончания.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Al evento ${i?.index} le falta una hora de finalización.
¿Desea cancelar la exportación?`)
};

const zh_cn2_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 缺少结束时间。

是否要中止导出？`)
};

const ja_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} に終了時刻が指定されていません。
エクスポートを中止しますか?`)
};

const hi_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में समाप्ति समय उपलब्ध नहीं है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_audio_description_export_event_missing_end = /** @type {(inputs: Audio_Description_Export_Event_Missing_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} não possui um horário de término.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} is missing an end time. Would you like to ABORT your export?" |
*
* @param {Audio_Description_Export_Event_Missing_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_event_missing_end = /** @type {((inputs: Audio_Description_Export_Event_Missing_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Event_Missing_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_event_missing_end(inputs)
	if (locale === "de") return de_audio_description_export_event_missing_end(inputs)
	if (locale === "it") return it_audio_description_export_event_missing_end(inputs)
	if (locale === "ru") return ru_audio_description_export_event_missing_end(inputs)
	if (locale === "es") return es_audio_description_export_event_missing_end(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_event_missing_end(inputs)
	if (locale === "ja") return ja_audio_description_export_event_missing_end(inputs)
	if (locale === "hi") return hi_audio_description_export_event_missing_end(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_event_missing_end(inputs)
	return en_audio_description_export_event_missing_end(inputs)
});